import { render, staticRenderFns } from "./SelectAmongList.vue?vue&type=template&id=5effc830&scoped=true&"
import script from "./SelectAmongList.vue?vue&type=script&lang=js&"
export * from "./SelectAmongList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5effc830",
  null
  
)

export default component.exports